export default {"src":"/_next/static/media/home_filled.ae05f803.svg","height":24,"width":24};